import RadioButtonModel from "@/chipply/RadioButtonModel";

export default class DesignWrapperModel {
    designs: RadioButtonModel[] = [];
    hasChildren = false;
}
